import React from 'react';

import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

interface PieChartProps {
    labels: string[];
    itemsData: number[];
}

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart: React.FC<PieChartProps> = (props) => {
    const { labels, itemsData } = props;

    const data = {
        labels: labels,
        datasets: [
            {
                // label: "Amounts Exc. VAT",
                data: itemsData,
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 99, 99, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(54, 75, 235, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 99, 99, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(54, 75, 235, 1)',
                ],
                borderWidth: 1,
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem) {
                            // const label = data.labels[tooltipItem.dataIndex];
                            const value = data.datasets[0].data[tooltipItem.dataIndex];
                            const percentage = ((value / data.datasets[0].data.reduce((a, b) => a + b)) * 100).toFixed(
                                2
                            );

                            return `${value.toLocaleString('fr-FR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}€ (${percentage}%)`;
                        },
                        title: function () {
                            return '';
                        },
                    },
                },
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
            tooltip: {
                enabled: true,
            },
        },
    };
    return <Pie data={data} options={options} />;
};

export default PieChart;
